import { apiService } from './api';

export interface PinData {
  pinnedCollections: string[];
  pinnedProblems: Record<string, string[]>;
  lastUpdated: number;
}

/**
 * Pins API Service
 * Handles all pin-related operations for collections and problems
 */
class PinsApiService {
  /**
   * Get user's pin preferences
   */
  async getPins(): Promise<PinData> {
    const response = await apiService.getUserPins();
    return response;
  }

  /**
   * Update user's pin preferences (bulk update)
   */
  async updatePins(pinData: PinData): Promise<PinData> {
    const response = await apiService.updateUserPins(pinData);
    return response;
  }

  /**
   * Pin a collection
   */
  async pinCollection(collectionId: string): Promise<PinData> {
    const response = await apiService.pinCollection(collectionId);
    return response;
  }

  /**
   * Unpin a collection
   */
  async unpinCollection(collectionId: string): Promise<PinData> {
    const response = await apiService.unpinCollection(collectionId);
    return response;
  }

  /**
   * Pin a problem within a collection
   */
  async pinProblem(collectionId: string, problemId: string): Promise<PinData> {
    const response = await apiService.pinProblem(collectionId, problemId);
    return response;
  }

  /**
   * Unpin a problem within a collection
   */
  async unpinProblem(collectionId: string, problemId: string): Promise<PinData> {
    const response = await apiService.unpinProblem(collectionId, problemId);
    return response;
  }
}

export const pinsApi = new PinsApiService();
